import React from "react";
import CustomersByYearStore from "../CustomersByYearStore";
import DatesHelper from "../../common/datesHelper";
import StringsHelper from "../../common/stringsHelper";
import { sumBy } from "lodash";

export default () => {
    const today = DatesHelper.Today();
    const items = CustomersByYearStore.useAll();
    if (!items)
        return <div />;

    return <div className="card card-inverse card-primary shadow">
        <div className="card-body">
            <div className="d-flex align-items center">
                <div className="me-5">
                    <i className="fas fa-chart-pie text-white fa-3x"></i>
                </div>
                <div>
                    <h3 className="text-white">Totale Clienti</h3>
                    <h6 className="card-subtitle text-uppercase">{DatesHelper.getMonthName(today, "it")} {today.getFullYear()}</h6>
                </div>
            </div>
            <div className="d-flex align-items-center text-white">
                <div className="d-flex align-items-center me-5">
                    <div><i className="fas fa-user-check fa-2x me-3" /></div>
                    <div>
                        <div>TOT. ATTIVI</div>
                        <div style={{ fontSize: "2rem" }} className="font-light ">
                            {StringsHelper.toIntegerString(sumBy(items, x => x.new))}
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <div><i className="fas fa-user-slash fa-2x me-3 text-danger" /></div>
                    <div>
                        <div>TOT. DISMESSI</div>
                        <div style={{ fontSize: "2rem" }} className="font-light ">
                            {StringsHelper.toIntegerString(sumBy(items, x => x.dismissed))}
                        </div>
                    </div>
                </div>
                <div style={{ marginRight: 0, marginLeft: "auto" }}>
                    <i className="fas fa-user-friends text-white fa-4x" />
                </div>
            </div>
        </div>
    </div>

}